<template>
  <Head :title="`Admin - Users - ${user.email} - Roles`"></Head>
  <admin-user-header :user="user" />
  <s-page-block size="md" class="flex-1">
    <form
      v-if="can.assignRoles"
      @submit.prevent="form.submit('post', route('admin.users.roles.store', {user: user.id}))"
      class="flex-1 flex max-w-full rounded-full focus-within:ring-2 focus-within:ring-blue-200"
      role="form"
    >
      <s-select
        id="role-selector"
        class="flex-1 min-w-[300px] !rounded-l-full !rounded-r-none !pl-4 focus:!ring-blue-200"
        label="Role"
        v-model.number="form.roleId"
        required
      >
        <option v-for="role in systemRoles" :key="role.id" :value="role.id">
          {{ role.name }}
        </option>
      </s-select>
      <s-btn
        id="search-submit"
        type="submit"
        class="flex-[0_0_auto] !px-6 !rounded-l-none"
        icon="plus"
        :processing="form.processing"
      >
        Assign Role
      </s-btn>
    </form>
    <table class="table">
      <thead>
        <tr>
          <th class="w-full">Role Name</th>
          <th class="w-0"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="userRole in userRoles">
          <td>{{ userRole.name }}</td>
          <td>
            <s-btn
              size="sm"
              color="red-light"
              icon="trash-can"
              method="delete"
              :href="
                route('admin.users.roles.destroy', {
                  user: user.id,
                  role: userRole.id,
                })
              "
              class="w-fit"
            >
              Delete
            </s-btn>
          </td>
        </tr>
        <tr v-if="!userRoles.length">
          <td colspan="4" class="text-center">User does not have any System Roles</td>
        </tr>
      </tbody>
    </table>
  </s-page-block>
</template>

<script setup lang="ts">
import {Head, router, useForm} from '@inertiajs/vue3';
import {route} from 'ziggy-js';
import SBtn from '../../../design-system/SBtn.vue';
import AdminUserHeader from '../../../layouts/AdminUserHeader.vue';
import SPageBlock from '../../../design-system/SPageBlock.vue';
import {User} from '../../../types/entities/user';
import SSelect from '../../../design-system/SSelect.vue';

type Role = {
  id: number;
  name: string;
};

defineProps<{
  user: User;
  systemRoles: Role[];
  userRoles: Role[];
  can: {
    assignRoles: boolean;
  };
}>();

const form = useForm({
  roleId: null as number | null,
});
</script>
